function _instanceof(left, right) {
  return null != right && "undefined" != typeof Symbol && right[Symbol.hasInstance] ? right[Symbol.hasInstance](left) : left instanceof right;
}
function _typeof(obj) {
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
  var _arr = [],
    _n = !0,
    _d = !1,
    _e = void 0;
  try {
    for (var _s, _i = arr[Symbol.iterator](); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), !(i && _arr.length === i)); _n = !0);
  } catch (err) {
    _d = !0, _e = err;
  } finally {
    try {
      _n || null == _i["return"] || _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _classCallCheck(instance, Constructor) {
  if (!_instanceof(instance, Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
  for (var descriptor, i = 0; i < props.length; i++) descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
}
function _createClass(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), Constructor;
}
function _possibleConstructorReturn(self, call) {
  return call && ("object" === _typeof(call) || "function" == typeof call) ? call : _assertThisInitialized(self);
}
function _inherits(subClass, superClass) {
  if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function");
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: !0,
      configurable: !0
    }
  }), superClass && _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  return _setPrototypeOf = Object.setPrototypeOf || function (o, p) {
    return o.__proto__ = p, o;
  }, _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return self;
}
import { createElement } from "react";
import PropTypes from "prop-types";
import BaseControl from "./base-control";
import { getDynamicPosition, ANCHOR_POSITION } from "../utils/dynamic-position";
var propTypes = Object.assign({}, BaseControl.propTypes, {
    className: PropTypes.string,
    longitude: PropTypes.number.isRequired,
    latitude: PropTypes.number.isRequired,
    offsetLeft: PropTypes.number,
    offsetTop: PropTypes.number,
    tipSize: PropTypes.number,
    closeButton: PropTypes.bool,
    closeOnClick: PropTypes.bool,
    anchor: PropTypes.oneOf(Object.keys(ANCHOR_POSITION)),
    dynamicPosition: PropTypes.bool,
    onClose: PropTypes.func
  }),
  defaultProps = Object.assign({}, BaseControl.defaultProps, {
    className: "",
    offsetLeft: 0,
    offsetTop: 0,
    tipSize: 10,
    anchor: "bottom",
    dynamicPosition: !0,
    closeButton: !0,
    closeOnClick: !0,
    onClose: function onClose() {}
  }),
  Popup = function (_BaseControl) {
    function Popup(props) {
      var _this;
      return _classCallCheck(this, Popup), _this = _possibleConstructorReturn(this, (Popup.__proto__ || Object.getPrototypeOf(Popup)).call(this, props)), _this._getPosition = _this._getPosition.bind(_assertThisInitialized(_this)), _this._onClose = _this._onClose.bind(_assertThisInitialized(_this)), _this._contentLoaded = _this._contentLoaded.bind(_assertThisInitialized(_this)), _this._renderTip = _this._renderTip.bind(_assertThisInitialized(_this)), _this._renderContent = _this._renderContent.bind(_assertThisInitialized(_this)), _this._closeOnClick = !1, _this;
    }
    return _inherits(Popup, _BaseControl), _createClass(Popup, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.forceUpdate();
      }
    }, {
      key: "_getPosition",
      value: function _getPosition(x, y) {
        var viewport = this.context.viewport,
          _this$props = this.props,
          anchor = _this$props.anchor,
          dynamicPosition = _this$props.dynamicPosition,
          tipSize = _this$props.tipSize;
        return this._content ? dynamicPosition ? getDynamicPosition({
          x: x,
          y: y,
          anchor: anchor,
          padding: tipSize,
          width: viewport.width,
          height: viewport.height,
          selfWidth: this._content.clientWidth,
          selfHeight: this._content.clientHeight
        }) : anchor : anchor;
      }
    }, {
      key: "_onClick",
      value: function _onClick(evt) {
        this.props.captureClick && evt.stopPropagation(), (this.props.closeOnClick || this._closeOnClick) && this.props.onClose();
      }
    }, {
      key: "_onClose",
      value: function _onClose() {
        this._closeOnClick = !0;
      }
    }, {
      key: "_contentLoaded",
      value: function _contentLoaded(ref) {
        this._content = ref;
      }
    }, {
      key: "_renderTip",
      value: function _renderTip() {
        var tipSize = this.props.tipSize;
        return createElement("div", {
          key: "tip",
          className: "mapboxgl-popup-tip",
          style: {
            borderWidth: tipSize
          }
        });
      }
    }, {
      key: "_renderContent",
      value: function _renderContent() {
        var _this$props2 = this.props,
          closeButton = _this$props2.closeButton,
          children = _this$props2.children;
        return createElement("div", {
          key: "content",
          ref: this._contentLoaded,
          className: "mapboxgl-popup-content"
        }, [closeButton && createElement("button", {
          key: "close-button",
          className: "mapboxgl-popup-close-button",
          type: "button",
          onClick: this._onClose
        }, "\xD7"), children]);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props3 = this.props,
          className = _this$props3.className,
          longitude = _this$props3.longitude,
          latitude = _this$props3.latitude,
          offsetLeft = _this$props3.offsetLeft,
          offsetTop = _this$props3.offsetTop,
          _this$context$viewpor = this.context.viewport.project([longitude, latitude]),
          _this$context$viewpor2 = _slicedToArray(_this$context$viewpor, 2),
          x = _this$context$viewpor2[0],
          y = _this$context$viewpor2[1],
          positionType = this._getPosition(x, y),
          anchorPosition = ANCHOR_POSITION[positionType],
          containerStyle = {
            position: "absolute",
            left: x + offsetLeft,
            top: y + offsetTop,
            transform: "translate(".concat(100 * -anchorPosition.x, "%, ").concat(100 * -anchorPosition.y, "%)")
          };
        return createElement("div", {
          className: "mapboxgl-popup mapboxgl-popup-anchor-".concat(positionType, " ").concat(className),
          style: containerStyle,
          ref: this._onContainerLoad
        }, [this._renderTip(), this._renderContent()]);
      }
    }]), Popup;
  }(BaseControl);
export { Popup as default };
Popup.displayName = "Popup", Popup.propTypes = propTypes, Popup.defaultProps = defaultProps;